import React from 'react';

import { Container, Wave } from './styles';

import SlideOne from './items/SlideOne';

const Slideshow: React.FC = () => {
  return (
    <Container>
      <SlideOne />

      <Wave xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6008 370">
        <path
          fill="#fff"
          d="M0,155S856.2-80.618,1884,31c863.36,93.76,1268,290.99,1620,311s992,19.635,1488-52S6008,151,6008,151V370H0V155Z"
        />
      </Wave>
    </Container>
  );
};

export default Slideshow;
